import type { FaireProductEntity } from "../../entity_types/product";

export const p_3hbnvwqpdm: FaireProductEntity = {
  token: "p_3hbnvwqpdm",
  type: "product",
  name: "Pineapple Notepad",
  brandName: "Island Haus Co",
  imageUrl:
    "https://cdn.faire.com/fastly/10c2eda724c378c641371776874e577eb237c0acf3e05a7de8cf6489ee8b44ec.png",
  priceDollars: 6,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/d6a1980bb8a7e9784ed4ebb6f8f884f6e23243ba12a89adc5c932e68ea0a600e.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
